<div *ngIf="title" class="banner-container {{theme}}">
    <div *ngIf="bannerIcon" class="banner-icon">
        <div class="d-flex" [innerHTML]="bannerIcon | safeHtml"></div>
    </div>
    <div class="banner-content">
        <div class="banner-title" [innerHTML]="title | safeHtml"></div>
        <div *ngIf="description" class="banner-description" [innerHTML]="description | safeHtml"></div>
    </div>
    <div *ngIf="buttonText" class="banner-button">
        <ng-container *ngIf="buttonUrl.indexOf('http') > -1 ; else routerlink">
            <button (click)="openInNewTab(buttonUrl)" mat-flat-button>{{buttonText}}</button>
        </ng-container>
        <ng-template #routerlink>
            <button *ngIf="!customHandler; else customClickHandler" [routerLink]="buttonUrl" mat-flat-button>{{buttonText}}</button>
            </ng-template>      
            <ng-template #customClickHandler>
                <button (click)="handleButtonClick($event)" mat-flat-button>{{buttonText}}</button>
            </ng-template>
    </div>
    <ng-container *ngIf="showCloseButton">
        <button class="close-button" (click)="closeBanner()">×</button>
    </ng-container>
</div>